(function (window, document) {
  'use strict';

  function getApi() {
    return window.buybackApi || null;
  }
  function getModals() {
    return window.buybackPortalModals || null;
  }
  function getHelpers() {
    return window.buybackPortalHelpers || null;
  }
  function getMeVendorType() {
    var me = window.__buybackMe;
    return me && me.vendorType === 'PRO' ? 'PRO' : 'PART';
  }
  function getApiBaseUrl() {
    var cfg = window.buybackPortalConfig;
    var raw = (cfg && typeof cfg.getApiBaseUrl === 'function' && cfg.getApiBaseUrl()) || '';
    return String(raw || '').replace(/\/?$/, '/');
  }

  function refreshList(listInstance) {
    if (listInstance && typeof listInstance._loadData === 'function') {
      listInstance._loadData();
    } else {
      window.location.reload();
    }
  }

  function onApiError(err, modals, listInstance) {
    if (err && err.message === 'HTTP_409') {
      if (modals) modals.closeCurrent();
      refreshList(listInstance);
      return;
    }
    if (modals) modals.closeCurrent();
  }

  function fetchReprise(id) {
    var api = getApi();
    if (!api || !id) return Promise.resolve(null);
    return api.getReprise(id).then(function (res) {
      return (res && res.reprise) || res || null;
    });
  }

  function tI18n(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || '';
  }

  function doAccept(r, listInstance) {
    var api = getApi();
    var toast = window.BuybackPortalToast;
    if (!api || !toast) return;
    var codeMint = r.code_mint || r.id;
    toast.confirmWithUndo({
      messageTpl: tI18n('toast_accept_pending_tpl') || 'Offre acceptée — appliqué dans {{ seconds }} s',
      message: tI18n('toast_accept_pending') || 'Offre acceptée — appliqué dans 3 s',
      undoLabel: tI18n('toast_undo') || 'Annuler',
      delayMs: 3000,
      onConfirm: function () {
        api
          .accept(r.id, { code_mint_confirm: codeMint, expectedUpdatedAt: r.updatedAt })
          .then(function () {
            refreshList(listInstance);
          })
          .catch(function (err) {
            onApiError(err, getModals(), listInstance);
          });
      },
    });
  }

  function doRefuse(r, listInstance) {
    var modals = getModals();
    var api = getApi();
    if (!modals || !api) return;
    var codeMint = r.code_mint || r.id;
    modals.openRefuse({
      onConfirm: function (payload, ctx) {
        var body = {
          code_mint_confirm: codeMint,
          expectedUpdatedAt: r.updatedAt,
          reason_predefined: payload.reason,
        };
        if (payload.comment) body.reason_text = payload.comment;
        if (ctx) ctx.setBusy(true);
        api
          .refuse(r.id, body)
          .then(function () {
            if (ctx) ctx.setBusy(false);
            modals.closeCurrent();
            refreshList(listInstance);
          })
          .catch(function (err) {
            if (ctx) ctx.setBusy(false);
            if (err && err.message === 'HTTP_409') {
              onApiError(err, modals, listInstance);
              return;
            }
            if (ctx && ctx.showError) ctx.showError();
          });
      },
    });
  }

  function doPickStore(r, listInstance) {
    var modals = getModals();
    var helpers = getHelpers();
    var api = getApi();
    if (!modals || !helpers || !api) return;
    var stores = helpers.parseStores ? helpers.parseStores() : [];
    var MINT = helpers.MINT_DIRECT_STORE_ID;
    var preMethod =
      helpers.isMintDirectStore && helpers.isMintDirectStore(r.boutique_hubspot_id)
        ? 'mint_direct'
        : helpers.isNoStoreNearby && helpers.isNoStoreNearby(r.boutique_hubspot_id)
          ? null
          : r.boutique_hubspot_id
            ? 'shop'
            : null;

    var persistChoice = function (storeId, ctx) {
      api
        .persistStoreChoice(r.id, storeId, r.updatedAt)
        .then(function () {
          if (ctx) ctx.setBusy(false);
          modals.closeCurrent();
          refreshList(listInstance);
        })
        .catch(function (err) {
          if (ctx) ctx.setBusy(false);
          if (err && err.message === 'INVALID_STORE_ID') return;
          if (ctx && ctx.showError) ctx.showError();
        });
    };

    var openShopStep = function () {
      modals.openStoreSelect(stores, {
        selectedId: null,
        onBack: function () {
          openMethodStep();
        },
        onSelect: function (store, ctx) {
          if (ctx) ctx.setBusy(true);
          persistChoice(store.id, ctx);
        },
        onNoStoreNearby: function (ctx) {
          if (ctx) ctx.setBusy(true);
          var NSN = helpers.NO_STORE_NEARBY_STORE_ID;
          var toast = window.BuybackPortalToast;
          var tInfo = function (k) {
            var i18n = window.buybackPortalI18n || {};
            return i18n[k] || '';
          };
          api
            .persistStoreChoice(r.id, NSN, r.updatedAt)
            .then(function () {
              if (ctx) ctx.setBusy(false);
              modals.closeCurrent();
              if (toast && typeof toast.info === 'function') {
                toast.info(tInfo('toast_no_store_nearby_info') || 'Pas de boutique proche — équipe notifiée', 4000);
              }
              refreshList(listInstance);
            })
            .catch(function (err) {
              if (ctx) ctx.setBusy(false);
              if (err && err.message === 'INVALID_STORE_ID') return;
              if (ctx && ctx.showError) ctx.showError();
            });
        },
      });
    };

    var openMethodStep = function () {
      modals.openDepotMethodSelect({
        selectedMethod: preMethod,
        onSelectMethod: function (method, ctx) {
          if (method === 'shop') {
            openShopStep();
            return;
          }
          if (ctx) ctx.setBusy(true);
          persistChoice(MINT, ctx);
        },
      });
    };

    openMethodStep();
  }

  function doPickPickupDate(r, listInstance) {
    var api = getApi();
    var helpers = getHelpers();
    var mod = window.buybackPortalModalPickupDate;
    if (!api || !mod || typeof mod.open !== 'function' || typeof api.persistPickupDate !== 'function') {
      // Fallback : ouvrir le détail (le user finalisera là-bas).
      navDetail(r.id);
      return;
    }

    function openModal(detail) {
      mod.open({
        repriseId: r.id,
        currentDate: detail.pickup_requested_date || '',
        currentSlot: detail.pickup_requested_slot || '',
        onConfirm: function (isoDate, slot, ctx) {
          api
            .persistPickupDate(r.id, {
              isoDate: isoDate,
              slot: slot,
              expectedUpdatedAt: detail.updatedAt || r.updatedAt || null,
              isPart: false,
            })
            .then(function () {
              // Marker session pour que le substep state détecte 'store_chosen'
              // dans la liste (où pickup_requested_date n'est pas sérialisé).
              try {
                sessionStorage.setItem('bp:pickup:' + r.id, '1');
              } catch (e) {}
              if (ctx && typeof ctx.close === 'function') ctx.close();
              refreshList(listInstance);
            })
            .catch(function (err) {
              if (helpers && typeof helpers.handlePickupDateError === 'function') {
                helpers.handlePickupDateError(err, ctx, {
                  onForbiddenForPart: function () {
                    if (ctx && typeof ctx.close === 'function') ctx.close();
                    refreshList(listInstance);
                  },
                  onStaleData: function () {
                    if (ctx && typeof ctx.close === 'function') ctx.close();
                    refreshList(listInstance);
                  },
                });
                return;
              }
              // Fallback minimal si helpers indisponible.
              if (ctx && typeof ctx.close === 'function') ctx.close();
              refreshList(listInstance);
            });
        },
      });
    }

    api
      .getReprise(r.id)
      .then(function (res) {
        var detail = (res && res.reprise) || r;
        openModal(detail);
      })
      .catch(function () {
        openModal(r);
      });
  }

  function doUploadDocs(r, listInstance) {
    var modals = getModals();
    if (!modals) return;
    modals.openDocsUpload({
      repriseId: r.id,
      vendorType: getMeVendorType(),
      apiBaseUrl: getApiBaseUrl(),
      onAllUploaded: function () {
        refreshList(listInstance);
      },
    });
  }

  function navDetail(repriseId) {
    if (!repriseId) return;
    window.location.hash = '#/detail/' + encodeURIComponent(repriseId);
  }

  function handleAction(action, repriseId, listInstance) {
    if (!repriseId) return;
    if (action === 'view-detail') {
      navDetail(repriseId);
      return;
    }
    fetchReprise(repriseId)
      .then(function (r) {
        if (!r) {
          navDetail(repriseId);
          return;
        }
        if (action === 'accept') return doAccept(r, listInstance);
        if (action === 'refuse') return doRefuse(r, listInstance);
        if (action === 'pick-store') return doPickStore(r, listInstance);
        if (action === 'pick-pickup-date') return doPickPickupDate(r, listInstance);
        if (action === 'upload-docs' || action === 'sign-contract') return doUploadDocs(r, listInstance);
        navDetail(repriseId);
      })
      .catch(function () {
        navDetail(repriseId);
      });
  }

  window.buybackPortalListActions = { handleAction: handleAction };
})(window, document);
